require('/opt/odin/app/frontend/pages/contests/index/index.module.scss');module.exports = "../../app/views/tms/contests/index.html.erb";